<div class="d-flex flex-column justify-content-start align-items-start h-100 w-100">

    <div class="bg-grey-lighter-color  w-100 mb-3 p-2">
        <span class="fs-5 fw-bolder">Datos del colegio</span>
    </div>

    <!-- Nombre del colegio -->
    <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-2">
        <span class="text-primary-color fw-bolder" [appAsterisk]="true">Nombre del colegio</span>
        <input type="text" pInputText class="w-100" [(ngModel)]="student.school" (ngModelChange)="onStudentChange()"/>
    </div>

    <!-- Localidad -->
    <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-2">
        <span class="text-primary-color fw-bolder" [appAsterisk]="true">Localidad</span>
        <input type="text" pInputText class="w-100" [(ngModel)]="student.location" (ngModelChange)="onStudentChange()"/>
    </div>

    <!-- Provincia -->
    <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-2">
        <span class="text-primary-color fw-bolder" [appAsterisk]="true">Provincia</span>
        <input type="text" pInputText class="w-100" [(ngModel)]="student.province" (ngModelChange)="onStudentChange()"/>
    </div>

    <!-- Código postal -->
    <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-2">
        <span class="text-primary-color fw-bolder" [appAsterisk]="true">Código postal</span>
        <input type="text" pInputText class="w-100" [(ngModel)]="student.postalCode" (ngModelChange)="onStudentChange()"/>
    </div>

</div>
